import styled from 'styled-components';
import { Subtitle, Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import DefaultSpinner from 'components/Spinner';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  margin: 1rem auto 2.625rem;
  text-align: center;
  max-width: 45rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(Subtitle)`
  font-weight: 700;
  margin-bottom: 0.75rem;
`;

// TODO: TFR-44 move to typography group
export const Description = styled(Body)`
  text-align: center;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-44 move to typography group
export const BoldText = styled.span`
  font-weight: 600;
`;

// TODO: TFR-44 move to spinner group
export const Spinner = styled(DefaultSpinner)`
  width: 2rem;
  height: 2rem;
  margin-bottom: 0.75rem;
`;
